// MeterTable.jsx - 电表遥测数据表
import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from '../../../../utils/useI18n';

const COLORS = { primary: '#00d4ff', muted: 'rgba(255,255,255,0.6)' };
const fmt0 = v => (v != null && !isNaN(v) ? (typeof v === 'number' ? v.toFixed(2) : v) : '-');
const fmtTime = t => t ? new Date(t).toLocaleString() : '-';

export default function MeterTable({ data }) {
  const { t } = useTranslation();

  const columns = [
    { title: 'SN', dataIndex: 'sn', key: 'sn', width: 110, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.globalNo'), dataIndex: 'global_no', key: 'global_no', width: 120, render: v => <span style={{ color: COLORS.primary }}>{v || '-'}</span> },
    { title: t('cloud.devNo'), dataIndex: 'dev_no', key: 'dev_no', width: 110, render: v => v || '-' },
    { title: t('cloud.deviceType'), dataIndex: 'device_type', key: 'device_type', width: 100, render: v => v || '-' },
    { title: t('cloud.type'), dataIndex: 'type', key: 'type', width: 90, render: v => v || '-' },
    { title: t('cloud.online'), dataIndex: 'online', key: 'online', width: 70, render: v => <Tag color={v === 1 ? 'green' : 'default'}>{v === 1 ? t('status.online') : t('status.offline')}</Tag> },
    { title: t('cloud.state'), dataIndex: 'state', key: 'state', width: 90, render: v => v || '-' },
    { title: t('cloud.reportMode'), dataIndex: 'report_mode', key: 'report_mode', width: 100, render: v => v || '-' },
    { title: t('cloud.intervalStart'), dataIndex: 'interval_start', key: 'interval_start', width: 160, render: v => v || '-' },
    { title: t('cloud.intervalEnd'), dataIndex: 'interval_end', key: 'interval_end', width: 160, render: v => v || '-' },
    { title: t('cloud.dataQuality'), dataIndex: 'data_quality', key: 'data_quality', width: 90, render: v => v || '-' },
    { title: t('cloud.mappingSource'), dataIndex: 'mapping_source', key: 'mapping_source', width: 100, render: v => v || '-' },
    { title: t('cloud.activePowerKw2'), dataIndex: 'active_power_kw', key: 'active_power_kw', width: 110, render: v => fmt0(v) },
    { title: t('cloud.reactivePowerKvar'), dataIndex: 'reactive_power_kvar', key: 'reactive_power_kvar', width: 110, render: v => fmt0(v) },
    { title: t('cloud.phaseAPowerKw'), dataIndex: 'a_phase_power_kw', key: 'a_phase_power_kw', width: 110, render: v => fmt0(v) },
    { title: t('cloud.phaseBPowerKw'), dataIndex: 'b_phase_power_kw', key: 'b_phase_power_kw', width: 110, render: v => fmt0(v) },
    { title: t('cloud.phaseCPowerKw'), dataIndex: 'c_phase_power_kw', key: 'c_phase_power_kw', width: 110, render: v => fmt0(v) },
    { title: t('cloud.aPhaseReactivePowerKvar'), dataIndex: 'a_phase_reactive_power_kvar', key: 'a_phase_reactive_power_kvar', width: 130, render: v => fmt0(v) },
    { title: t('cloud.bPhaseReactivePowerKvar'), dataIndex: 'b_phase_reactive_power_kvar', key: 'b_phase_reactive_power_kvar', width: 130, render: v => fmt0(v) },
    { title: t('cloud.cPhaseReactivePowerKvar'), dataIndex: 'c_phase_reactive_power_kvar', key: 'c_phase_reactive_power_kvar', width: 130, render: v => fmt0(v) },
    { title: t('cloud.aPhaseVoltageV'), dataIndex: 'a_phase_voltage_v', key: 'a_phase_voltage_v', width: 110, render: v => fmt0(v) },
    { title: t('cloud.bPhaseVoltageV'), dataIndex: 'b_phase_voltage_v', key: 'b_phase_voltage_v', width: 110, render: v => fmt0(v) },
    { title: t('cloud.cPhaseVoltageV'), dataIndex: 'c_phase_voltage_v', key: 'c_phase_voltage_v', width: 110, render: v => fmt0(v) },
    { title: t('cloud.aPhaseCurrentA'), dataIndex: 'a_phase_current_a', key: 'a_phase_current_a', width: 110, render: v => fmt0(v) },
    { title: t('cloud.bPhaseCurrentA'), dataIndex: 'b_phase_current_a', key: 'b_phase_current_a', width: 110, render: v => fmt0(v) },
    { title: t('cloud.cPhaseCurrentA'), dataIndex: 'c_phase_current_a', key: 'c_phase_current_a', width: 110, render: v => fmt0(v) },
    { title: t('cloud.powerFactor'), dataIndex: 'power_factor', key: 'power_factor', width: 90, render: v => fmt0(v) },
    { title: t('cloud.importEnergyKwh'), dataIndex: 'import_energy_kwh', key: 'import_energy_kwh', width: 120, render: v => fmt0(v) },
    { title: t('cloud.exportEnergyKwh'), dataIndex: 'export_energy_kwh', key: 'export_energy_kwh', width: 120, render: v => fmt0(v) },
    { title: t('cloud.frequencyHz'), dataIndex: 'frequency_hz', key: 'frequency_hz', width: 90, render: v => fmt0(v) },
    { title: t('cloud.recordedAt'), dataIndex: 'recorded_at', key: 'recorded_at', width: 160, render: fmtTime },
  ];

  if (!data || data.length === 0) return null;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ color: COLORS.muted, fontSize: 12, marginBottom: 8 }}>{t('cloud.telemetryMeter')}</div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        pagination={{ pageSize: 5, showSizeChanger: false }}
        scroll={{ x: 4200 }}
        style={{ background: 'transparent' }}
      />
    </div>
  );
}
